function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useEffect } from 'react';
import useRafState from "./useRafState";
import { off, on } from "./misc/util";

var useScroll = function useScroll(ref) {
  if (process.env.NODE_ENV === 'development') {
    if (_typeof(ref) !== 'object' || typeof ref.current === 'undefined') {
      console.error('`useScroll` expects a single ref argument.');
    }
  }

  var _a = useRafState({
    x: 0,
    y: 0
  }),
      state = _a[0],
      setState = _a[1];

  useEffect(function () {
    var handler = function handler() {
      if (ref.current) {
        setState({
          x: ref.current.scrollLeft,
          y: ref.current.scrollTop
        });
      }
    };

    if (ref.current) {
      on(ref.current, 'scroll', handler, {
        capture: false,
        passive: true
      });
    }

    return function () {
      if (ref.current) {
        off(ref.current, 'scroll', handler);
      }
    };
  }, [ref]);
  return state;
};

export default useScroll;